// Los empleados se piden al hacer login y se persisten (redux-persist). Si
// esa petición se pierde — por ejemplo, el usuario recarga o navega justo
// después de entrar y el navegador aborta el GET — la lista queda vacía para
// siempre: sin selector de empleado, sin «Fichar» y sin kiosko hasta volver a
// iniciar sesión. La barra superior la vuelve a pedir al montarse en ese caso.
export function shouldRefetchEmployees(employees, user, isPersonalEmployeeSession) {
  if (!user || isPersonalEmployeeSession) return false;
  return !Array.isArray(employees) || employees.length === 0;
}
